import { render, staticRenderFns } from "./submitQuaOrder.vue?vue&type=template&id=3bb5e9f7&scoped=true"
import script from "./submitQuaOrder.vue?vue&type=script&lang=js"
export * from "./submitQuaOrder.vue?vue&type=script&lang=js"
import style0 from "./submitQuaOrder.vue?vue&type=style&index=0&id=3bb5e9f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb5e9f7",
  null
  
)

export default component.exports